class GuestAdditionController {

  constructor(basket, guestnameService, propertyService, loginoutService, addGuestService, configService) {
    this.basket = basket;
    this.guestnameService = guestnameService;
    this.propertyService = propertyService;
    this.loginoutService = loginoutService;
    this.addGuestService = addGuestService;
    this.configService = configService;
  }

  $onInit () {
    this.displayGender = this.configService.get('property').displayGender;
    
    if (this.basket && this.basket.promise) {
      return this.basket.promise.then(() => {
        this.addGuestService.setState({
          existingGuests: this.basket.contents.guest_details,
          gender: this.gender,
          minimumGuests: this.minimumGuests,
          maximumGuests: this.maximumGuests
        });
        this.addGuestService.buildTitlesList();
        const existingGuests = this.addGuestService.filterExistingGuests()
          .filter(guest => !guest.disabled);

        if (this.loginoutService.isEditing()) {
          if (existingGuests.length === 0) {
            this.error = `Sorry, you are not able to add any guests to this event.`;
            return;
          }

          if (existingGuests.length < this.minimumGuests) {
            this.error = `Sorry, you do not have enough guests available to add this event.`;
          }
        }
      });
    }
  }

  canAddGuest () {
    if (this.loginoutService.isEditing()) {
      return false;
    }

    return this.addGuestService.canAddGuest();
  }

  addExistingGuest () {
    this.addGuestService.addExistingGuest(this.existingGuestId);
  }

  loadStaff () {
    return !!(this.propertyService.get('loadStaff') && this.staff && this.staff.length);
  }

  allGuestsSelected () {
    return !this.addGuestService.getState('existingGuests')
      .find(guest => !guest.disabled);
  }

  showRemoveButton () {
    return this.addGuestService.getGuests().length > this.minimumGuests;
  }

  disableExistingGuests () {
    return this.addGuestService.maxGuestsAdded() || this.allGuestsSelected() || this.basket.saving;
  }
}

GuestAdditionController.$inject = [ 'basket', 'guestnameService', 'propertyService', 'loginoutService', 'addGuestService', 'configService' ];

export default GuestAdditionController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/guest/controllers/guest.addition.controller.js